<template>
    <div class="card shadow-sm mb-4">
        <div class="card-header text-white bg-secondary fw-bold">Scenarios Approved</div>
        <div class="card-content">
            <div v-if="!visit_loading">
                <div v-if="Object.keys(props.scenario_approved).length">
                    <div v-for="approved in props.scenario_approved" v-bind:key="approved.id" class="row scenario-card" @click="router.push({name:'scenario.show',params:{id:approved.id}})">
                        <div class="col-md-10">
                            <img :src="approved.patient_image.location" class="rounded-circle float-start" width="75" />
                            <div class="fw-bold text-secondary">{{approved.patient_name}}</div>
                            <div class="overflow-hidden">
                                <span>{{approved.title}}</span>
                            </div>
                        </div>
                        <div class="col-md-2 d-flex flex-column justify-content-center">
                            <h3 class="text-center"><i class='fas fa-check-circle text-primary'></i></h3>
                        </div>
                        <br/>
                        <div class="col-12 thin-line"></div>
                    </div>
                    <pagination v-if="Object.keys(props.scenario_approved).length > 10" :items="props.scenario_approved" :page_start="page_start" :page_end="page_end" v-on:next-page="nextPage" v-on:previous-page="previousPage" :label="'Scenarios'" />
                </div>
                <p v-else class="text-center pt-3">No Scenarios have been Approved</p>
            </div>
            <div class="loading-card-area" v-else>
                <loading :active="visit_loading" :is-full-page="false"></loading>
            </div>
        </div>
    </div>
</template>

<script lang="ts">
    import {defineComponent, ref} from "vue";
    import Loading from 'vue3-loading-overlay';
    import Pagination from '@/components/dashboard/pagination.vue';
    import router from "@/router";

    export default defineComponent({
        components: {
            Loading,
            Pagination
        },
        props: {
            scenario_approved: {type:Object, required:true},
            visit_loading: {type:Boolean, required:true}
        },
        setup(props) {
            const page_start = ref(0);
            const page_end = ref(10);
            const nextPage = async() => {
                page_start.value = page_start.value + 10;
                page_end.value = page_end.value + 10;
                if(page_end.value > Object.keys(props.scenario_approved).length){
                    page_end.value = Object.keys(props.scenario_approved).length;
                }
            };
            return {
                nextPage,
                page_end,
                page_start,
                props,
                router
            };
        }
    });
</script>
